export default "__VITE_ASSET__CeH$nIm1__";